// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TagsLandingContainer_YiyZK {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-direction: column;
  width: 100%;
  margin-top: 40px;
}

.tagLanding_FcB_H {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
}

.tag_csg6q {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: var(--white-color);
  width: fit-content;
  padding: 10px;
  text-align: center;
  border: 1px solid #dcdcdc;
  border-radius: 99px;
  -webkit-border-radius: 99px;
  -moz-border-radius: 99px;
  -ms-border-radius: 99px;
  -o-border-radius: 99px;
  max-width: 500px;
  color: #676767;
  justify-content: center;
  font-size: 14px;
  box-sizing: border-box;
  img {
    width: 20px;
    height: 20px;
  }
  svg {
    width: 15px;
    height: 15px;
    min-width: 15px;

  }
}

@media (max-width: 940px) {
  .tagLanding_FcB_H {
    flex-direction: column;
    width: 100%;
  }
  .tag_csg6q {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/TagsLanding/TagsLanding.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;;EAEjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".TagsLandingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 40px;\n}\n\n.tagLanding {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n}\n\n.tag {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background-color: var(--white-color);\n  width: fit-content;\n  padding: 10px;\n  text-align: center;\n  border: 1px solid #dcdcdc;\n  border-radius: 99px;\n  -webkit-border-radius: 99px;\n  -moz-border-radius: 99px;\n  -ms-border-radius: 99px;\n  -o-border-radius: 99px;\n  max-width: 500px;\n  color: #676767;\n  justify-content: center;\n  font-size: 14px;\n  box-sizing: border-box;\n  img {\n    width: 20px;\n    height: 20px;\n  }\n  svg {\n    width: 15px;\n    height: 15px;\n    min-width: 15px;\n\n  }\n}\n\n@media (max-width: 940px) {\n  .tagLanding {\n    flex-direction: column;\n    width: 100%;\n  }\n  .tag {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TagsLandingContainer": `TagsLandingContainer_YiyZK`,
	"tagLanding": `tagLanding_FcB_H`,
	"tag": `tag_csg6q`
};
export default ___CSS_LOADER_EXPORT___;
